import { MedicalOrderScannType } from './medical-order-scann-type';
export class MedicalOrderScannRequest {
  public MedicalOrderScannId: number;
  public TemporaryImageId: number;
  public MedicalOrderId: number;
  public MedicalOrderScannType: MedicalOrderScannType;
  public Upload: boolean;
}
